import {
  IFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import WishStepBuy_1 from "../wishSteps/buy/step_1";
import WishStepBuy_2 from "../wishSteps/buy/step_2";
import WishStepBuy_3 from "../wishSteps/buy/step_3";
import WishStepBuy_4 from "../wishSteps/buy/step_4";
import WishStepBuy_5 from "../wishSteps/buy/step_5";

const getWishBuySteps = (
  data: IFillDataWizardBuy,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStep_communicationType: boolean;
    isNextStep_timeIntervalTypeView: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
  }
) => {
  // если не знает что хочет преобрести не соберается продавать квартиру

  const {
    isNextStep_communicationType,
    isNextStep_timeIntervalTypeView,
    isNextStep_viewRealtorParticipation,
    isNextStep_timeIntervalTypeCommunication,
  } = disabledAndPrev;

  return [
    <WishStepBuy_1
      onChange={handleChangeDataString}
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onReset={onReset}
    />,
    <WishStepBuy_2
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <WishStepBuy_3
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <WishStepBuy_4
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeView}
      isNextStepDisabled={isNextStep_timeIntervalTypeView}
      onReset={onReset}
    />,
    <WishStepBuy_5 data={data} />,
  ];
};

export default getWishBuySteps;
